import { Injectable } from '@angular/core';
import { HttpFamilyProvider } from '../providers/http-family';

/**
 * Generated class for the FamilyPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Injectable()
export class FamilyAction {

  constructor(
		private httpFamilyProvider:HttpFamilyProvider,
  	) {
  }

  /**
   * 一覧取得
   */
  getList(conditions){
    return this.httpFamilyProvider.getList(conditions);
  }
}


// WEBPACK FOOTER //
// ./src/actions/family.action.ts